export * from './src/loading-spinner.module';
